<template>

  <select-input
    :label="label"
    v-model="formData"
    value-key="value"
    label-value="label"
    :placeholder="placeholder"
    :size="size"
    :list="selectData"
    :required="required"
    :disabled="disabled"
    :no-form="noForm"
    @change="updated"
  />

</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'

export default {
  name: 'select-org-category',

  mixins: [ArrayMixins],

  props: {

    label: {
      type: String,
      default: 'Category'
    },

    value: {
      //      type: String,
      required: true
    },

    size: {
      type: String,
      default: 'normal'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    removeTowerCo: {
      type: Boolean,
      default: true
    },

    noForm: {
      type: Boolean,
      default: false
    },

    // XOL-375: anonymous callers (Register.vue) can't reach the JWT-gated
    // GET /api/system/config, so they fetch category options from the
    // public GET /api/registration/metadata endpoint and pass them here.
    // When provided, this list is used instead of getConfig().selects.orgCategory.
    // Authenticated callers omit this prop and are unaffected.
    list: {
      type: Array,
      default: null
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },

    applyRemoveTowerCo () {
      if (this.removeTowerCo) {
        let ind = this.findIndex('value', 'Tower Company', this.selectData)
        if (ind >= 0) {
          this.selectData = this.arrayRemove(this.selectData, ind)
        }
      }
    }
  },

  watch: {
    // list arrives asynchronously (the parent's metadata GET resolves after
    // this component has already mounted with an empty/null list), so it
    // must be re-applied when the prop updates - not just read once in data().
    list: function (list) {
      if (list) {
        this.selectData = list
        this.applyRemoveTowerCo()
      }
    }
  },

  data () {
    return {
      formData: this.value,
      selectData: this.list ? this.list : this.getConfig().selects.orgCategory
    }
  },

  created () {
    this.applyRemoveTowerCo()
  }
}
</script>
